module.exports = new __parcel__URL__("maxime-pouezevara.967c1355.jpeg").toString();